<template>
  <div>
    <send-test-modal
      @send="sendTest"
    />
  </div>
</template>

<script>
import SendTestModal from '@/components/SendTestModal'
import {successNotification} from '@/notifications'
import gateway from '@/gateway'

export default {
  components: {
    SendTestModal,
  },
  props: {
    articleId: {
      required: true,
      type: [String, Number],
    },
    type: {
      required: false,
      type: String,
      default: null,
    },
  },
  methods: {
    sendTest (users) {
      let url = '/alerts/'

      if (this.type !== 'alert') {
        url += `test/${this.articleId}/${typeof this.articleId === 'string' ? 'article-draft' : 'article'}`
      } else {
        url += `${this.articleId}/test`
      }

      gateway.post(url, {
        users,
      }).then(() => {
        this.$modal.hide('send-test')
        this.$notify(successNotification('Sent a test to those users'))
      })
    },
  },
}
</script>
